const config = Object.assign({
  authCookie: 'li.auth'
},
  require(`./environments/${process.env.NODE_ENV}`).default
)

export default config



// WEBPACK FOOTER //
// ./src/config/index.js